export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.announcements': 'Announcements',
  'menu.policies': 'Policies',
  'menu.supplies': 'Supplies',
  'menu.supplies.workbench': 'Workbench',
  'menu.supplies.inventory': 'Inventory',
  'menu.supplies.receive': 'Receive',
  'menu.supplies.purchase': 'Purchase',
  'menu.supplies.check': 'Stocktake',
  'menu.supplies.rule': 'Rules',
  'menu.supplies.statistics': 'Statistics',
  'menu.supplies.workflow': 'Workflow',
  'menu.meetings': 'Meetings',
  'menu.meetings.calendar': 'My Meetings',
  'menu.meetings.bookings': 'Bookings',
  'menu.meetings.rooms': 'Rooms',
  'menu.meetings.minutes': 'Meeting Minutes',
  'menu.meetings.reports': 'Utilization Report',
  'menu.meetings.dashboard': 'Dashboard',
  'menu.meetings.settings': 'Settings',
  'menu.meetings.settings.booking': 'Booking Rules',
  'menu.meetings.settings.facilities': 'Room Settings',
  'menu.meetings.settings.locations': 'Locations & Floors',
  'menu.meetingRoomDashboard': 'Dashboard',
  'menu.meetingRoomRooms': 'Rooms',
  'menu.meetingRoomBookings': 'Bookings',
  'menu.meetingRoomCalendar': 'My Meetings',
  'menu.meetingRoomMinutes': 'Meeting Minutes',
  'menu.meetingRoomUtilizationReport': 'Utilization Report',
  'menu.meetingRoomSettings': 'Settings',
  'menu.meetingRoomBookingConfig': 'Booking Rules',
  'menu.meetingRoomFacilityTags': 'Room Settings',
  'menu.meetingRoomLocationConfig': 'Locations & Floors',
  'menu.meetingRoomFloorPlan': 'Floor Plan',
  'menu.greenPlants': 'Green plants',
  'menu.greenplant': 'Green Plants',
  'menu.greenplant.dashboard': 'Plant Workbench',
  'menu.greenplant.assets': 'Plant Register',
  'menu.greenplant.spacePoints': 'Space Points',
  'menu.greenplant.tasks': 'Care Operations',
  'menu.greenplant.issues': 'Issue Handling',
  'menu.greenplant.insights': 'Operations Insights',
  'menu.greenplant.settings': 'Configuration',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.settings': 'System Settings',
  'menu.settings.modelSettings': 'Model Settings',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
